import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AgentChatProvider } from './context/AgentChatContext';
import { RivhitDataProvider } from './context/RivhitDataContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Settings from './pages/Settings';
import Orders from './pages/Orders';
import Documents from './pages/Documents';
import CreateDocument from './pages/CreateDocument';
import Reports from './pages/Reports';
import Customers from './pages/Customers';
import Items from './pages/Items';
import Helper from './pages/Helper';
import Overview from './pages/Overview';
import Signals from './pages/Signals';
import Conversations from './pages/Conversations';
import Reminders from './pages/Reminders';
import Entities from './pages/Entities';
import Review from './pages/Review';
import Invoicing from './pages/Invoicing';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AgentChatProvider>
          <Routes>
            {/* Public route */}
            <Route path="/" element={<Landing />} />

            {/* Protected routes inside Layout */}
            <Route
              element={
                <ProtectedRoute>
                  <RivhitDataProvider>
                    <Layout />
                  </RivhitDataProvider>
                </ProtectedRoute>
              }
            >
              <Route path="/orders" element={<Orders />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/items" element={<Items />} />
              <Route path="/helper" element={<Helper />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/create-document" element={<CreateDocument />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/signals" element={<Signals />} />
              <Route path="/conversations" element={<Conversations />} />
              <Route path="/reminders" element={<Reminders />} />
              <Route path="/entities" element={<Entities />} />
              <Route path="/invoicing" element={<Invoicing />} />
              <Route path="/review" element={<Review />} />
              <Route path="/settings" element={<Settings />} />
            </Route>

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/documents" replace />} />
          </Routes>
        </AgentChatProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
